import template from './template.html';
import GenericPage from '../page/view';

export default {
    extends: GenericPage,
    name: 'casesPage',
    template: template,
};